export default {
    queue_position: 'Posición en la fila: {{position}}',
    chat_closed: 'Chat Cerrado',
    waiting_agent: 'En espera de servicio. Posición {{position}}',
    error_send_message: 'Hubo un problema al enviar este mensaje. Haga clic aquí para intentarlo de nuevo',
    message_action: {
        closed: 'El chat finalizó el {{date}} por {{name}}',
        queue_position: '<p class="m-0">Espere a que un agente responda a su solicitud.</p>' +
            'Está en la <b>posición {{position}}</b> de la cola de servicio.',
        agent_entered: '<b>{{name}}</b> se unió al chat.',
        transferred_agent: 'Chat transferido a <b>{{name}}</b>',
        created_ticket: 'El ticket <b>{{number}}</b> se abrió desde este chat',
    }
}
